module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('section', [_c('div', {
    staticClass: "cover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('h1', [_vm._v("联系我们")]), _vm._v(" "), _c('el-input', {
    staticClass: "user-name",
    attrs: {
      "placeholder": "怎么称呼您"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择问题类型"
    },
    model: {
      value: (_vm.questionType),
      callback: function($$v) {
        _vm.questionType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "questionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "融资问题",
      "value": "融资问题"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "供应商注册问题",
      "value": "供应商注册问题"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "银行或其他金融机构",
      "value": "银行或其他金融机构"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "企业推荐",
      "value": "企业推荐"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "客户手机号或邮箱"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "您的公司名称"
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyName"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "问题描述"
    },
    model: {
      value: (_vm.questionDetail),
      callback: function($$v) {
        _vm.questionDetail = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "questionDetail"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("提交")])], 1)])]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address', [_c('h1', [_vm._v("您可以填写右边的表格，我们会尽快与您联系。您也可以按照以下电话和地址与我们取得联系。")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("400-622-8098")]), _vm._v(" "), _c('div', {
    staticClass: "mes"
  }, [_vm._v("200030")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v("上海市徐汇区中山南二路107号"), _c('br'), _vm._v("美奂大厦11层A单元")]), _vm._v(" "), _c('h2', [_vm._v("在地图上找我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://map.baidu.com/?newmap=1&s=inf%26uid%3D11f3652ca38d1d70077ce835%26wd%3D%E7%BE%8E%E5%A5%82%E5%A4%A7%E5%8E%A6%26all%3D1%26c%3D289&from=alamap&tpl=map_singlepoint",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "map",
    attrs: {
      "src": "/imgs/portal/contact/shanghai@2x.jpg",
      "alt": "map"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3d9f9384"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Contact.vue
// module id = 1301
// module chunks = 26